/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-key */
import React, { useState } from 'react';
import { Button, Divider, Form, message, Select, Spin, Switch } from 'antd-v5';
import { connect } from 'react-redux';
import { useQuery } from 'react-query';
import StandardLayoutV2 from '../../../../Layout/StandardLayoutV2';
import { getMessageSettings, saveMessageSettings } from '../../../../../core/apiRequests';
import {
  bodyFormatter,
  messageDispatcher,
} from '../../../../../components/Routes/Configuration/MessageSettings/largeMsgSettingFns';
import { SettingsContent } from '../../components/SettingsContent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DescriptionBox from '../../../../../components/Layout/DescriptionBox';
import TextAreaWithActions from '../../../../../components/Layout/TextAreaWithActions';
import useActionTextAreaFiles, {
  actionTextAreaFileActions,
} from '../../../../../components/Layout/TextAreaWithActions/useActionTextAreaFiles';
import yn from 'yn';
import { MessagingSettings } from './components/messaging';
import { MarketingSettings } from './components/marketing';

const MessageSettings = ({ merchantId, stores, brandName }) => {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const [fileData, fileDispatch] = useActionTextAreaFiles();

  const { isFetching, refetch } = useQuery(
    ['messagingSettings', merchantId],
    async () => {
      const response = await getMessageSettings('merchant', merchantId);
      if (response) {
        messageDispatcher(response);
        fileDispatch({
          type: actionTextAreaFileActions.setImages,
          payload: { urls: response?.REVIEW_IMAGES_URL, files: [] },
        });
        const data = {
          defaultStore: response?.DEFAULT_STORE ? parseInt(response?.DEFAULT_STORE, 10) : undefined,
          setSchTime: response?.AUTO_MSG_TIME || undefined,
          autoAsA2p: yn(response?.AUTO_AS_A2P) || false,
          autoCloseTime: response?.AUTO_CLOSE_MIN_DAYS ? parseInt(response?.AUTO_CLOSE_MIN_DAYS, 10) : 90,
          reviewMessage: response?.REVIEW_MESSAGE || '',
          declutteredInbox: yn(response?.DECLUTTERED_INBOX) || false,
          allStoreConversationHistory: yn(response?.ALL_STORE_CONVERSATION_HISTORY) || false,
          doubleOptIn: yn(response?.double_opt_in) || false,
          delayOptIn: !yn(response?.DELAY_OPT_IN),
          optInInvite:
            response?.OPT_IN_INVITE ||
            `Hi :name:, It's :associate: from ${brandName} and you can reach me anytime at this number. Can I occasionally let you know about personalized promotions and products? If that's ok, reply YES to this msg`,
          optInBulkInvite:
            response?.OPT_IN_BULK_INVITE ||
            `Hi :name:, It's :associate: from ${brandName}. I have a message I'd like to send you but need your permission. I'll also occasionally let you know about personalized promotions and products? If that's ok, reply YES`,
          optInConfirm:
            response?.OPT_IN_CONFIRM ||
            ":name:, thanks for agreeing to let us contact you! You are free to reply STOP if you don't want to hear from us anymore. freq varies, msg&data rates apply",
        };
        form.setFieldsValue(data);
      }
    },
    {
      enabled: !!merchantId,
      refetchOnWindowFocus: false,
    },
  );

  const handleSave = async () => {
    setSaving(true);
    try {
      await form.validateFields();
      const values = await form.validateFields();
      const body = bodyFormatter({
        ...values,
        reviewImages: fileData,
        merchantConfig: {
          DECLUTTERED_INBOX: values.declutteredInbox,
        },
      });
      await saveMessageSettings('merchant', merchantId, body, 'messageConfig');
      refetch();
      message.success('Message settings saved successfully');
    } catch (error) {
      console.error('Failed to save settings:', error);
      if (error.errorFields && error.errorFields.length > 0) {
        error.errorFields.forEach(err => {
          message.error(err.errors[0]);
        });
      } else {
        message.error('Failed to save Message settings');
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <StandardLayoutV2
      title="Message Settings"
      description="Configure your message preferences below"
      classProps="flex-col-left"
      maxWidth="650px"
      styleProps={{ justifyContent: 'flex-start' }}
      containerStyles={{ backgroundColor: 'transparent', paddingRight: '32px', maxWidth: '650px' }}
      actions={
        <Button type="primary" onClick={handleSave} loading={saving} disabled={isFetching}>
          Save
        </Button>
      }
    >
      <Spin spinning={isFetching}>
        <Form form={form} layout="vertical" className="w-100-P" disabled={isFetching || saving}>
          <MessagingSettings form={form} stores={stores} fileData={fileData} fileDispatch={fileDispatch} />
          <Divider />
          <MarketingSettings form={form} brandName={brandName} />
        </Form>
      </Spin>
    </StandardLayoutV2>
  );
};

const mapStateToProps = state => ({
  merchantId: state.auth.merchantId,
  stores: state.auth.stores,
  brandName: state.auth.brandName,
});
export default connect(mapStateToProps, {})(MessageSettings);
